var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "package-base" } },
    [
      _c(
        "div",
        {
          staticClass:
            "sticky top-18 z-10 px-6 h-12 flex-shrink-0 flex items-center justify-between gap-y-2 gap-x-4 bg-pure-white border-b border-slate-400"
        },
        [_c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "py-6 px-6 w-full flex flex-col items-center" },
        [
          _vm.pageLoading
            ? _c(
                "div",
                { staticClass: "h-128 w-full grid place-items-center" },
                [_c("div", { staticClass: "blum-loader" })]
              )
            : _c(
                "div",
                { staticClass: "w-full max-w-180 flex flex-col gap-5" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-6 flex items-center justify-between gap-3"
                    },
                    [
                      _c("BlTextTitle3", {
                        staticClass: "truncate",
                        attrs: {
                          title: _vm.creditPackage.name,
                          text: _vm.creditPackage.name
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-center gap-3" },
                        [
                          _c("BlInputButton", {
                            attrs: { type: "outlined", label: "Edit" },
                            on: {
                              clicked: function($event) {
                                _vm.editOpened = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.creditPackage.status === "archived"
                            ? _c("BlInputButton", {
                                attrs: {
                                  label: "Reactivate",
                                  loading: _vm.submitLoading
                                },
                                on: { clicked: _vm.onReactivate }
                              })
                            : _c("BlInputButton", {
                                attrs: { type: "outlined", label: "Archive" },
                                on: {
                                  clicked: function($event) {
                                    _vm.archiveOpened = true
                                  }
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-6 pt-2 flex gap-4 border-b border-slate-400"
                    },
                    _vm._l(_vm.tabs, function(tab) {
                      return _c(
                        "router-link",
                        {
                          key: tab.target,
                          staticClass:
                            "py-1 w-full flex items-center justify-center rounded-t border-b-4 hover:bg-hover-state transition-all duration-300",
                          class: [
                            tab.isActive
                              ? "border-light-purple"
                              : "border-transparent"
                          ],
                          attrs: { to: tab.target }
                        },
                        [
                          _c("BlTextBody1", {
                            class: { "font-bold": tab.isActive },
                            attrs: { text: tab.label }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  !_vm.$route.params.tab ? _c("PackageDetails") : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.params.tab === "history"
                    ? _c("PackageUsageHistory")
                    : _vm._e()
                ],
                1
              )
        ]
      ),
      _vm._v(" "),
      _vm.editOpened
        ? _c("EditPackageModal", {
            attrs: { creditPackage: _vm.creditPackage },
            on: {
              "close-modal": function($event) {
                _vm.editOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.archiveOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Archive package",
                label: "Archive package",
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.archiveOpened = false
                },
                "backdrop-action": _vm.onArchive
              }
            },
            [
              _c("div", { staticClass: "px-8", style: { width: "40rem" } }, [
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "You are about to archive" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "font-bold",
                      attrs: { text: _vm.creditPackage.name + "." }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "Archiving this package will make it unavailable for new credit transaction. However, it will remain linked to any existing appointments or credits."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "Are you sure you want to proceed?" }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a9b7b32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9b7b32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/CenterPackage.vue
// module id = null
// module chunks = 